import { useRef } from "react";

/** Drag-to-move + corner-resize handles drawn over the canvas for the selected
 *  overlay. x/y are the overlay's centre (fraction of frame); w is its width
 *  (fraction of frame width); height follows the overlay's natural aspect.
 *  Rendered as a child of the canvas wrapper, so percentages map to the frame. */
export default function OverlayHandles({ clip, aspect, onChange, trackId }) {
  const ref = useRef(null);
  if (!clip) return null;
  const ar = aspect || 16 / 9;
  const w = clip.w ?? 0.5;
  const hFrac = (w * (16 / 9)) / ar;            // width is a fraction of frame width
  const x = clip.x ?? 0.5, y = clip.y ?? 0.5;
  const rect = () => ref.current?.parentElement?.getBoundingClientRect();

  const drag = (e, mode) => {
    e.stopPropagation(); e.preventDefault();
    const r = rect(); if (!r) return;
    const sx = e.clientX, sy = e.clientY, ox = x, oy = y, ow = w;
    const move = (ev) => {
      if (mode === "move") {
        onChange(trackId, clip.id, {
          x: Math.max(0, Math.min(1, ox + (ev.clientX - sx) / r.width)),
          y: Math.max(0, Math.min(1, oy + (ev.clientY - sy) / r.height)),
        }, false);
      } else {
        // resize from the centre (x/y fixed): a corner moves both edges
        onChange(trackId, clip.id, { w: Math.max(0.05, Math.min(1.5, ow + ((ev.clientX - sx) / r.width) * 2)) }, false);
      }
    };
    const up = () => { onChange(trackId, clip.id, {}, true); window.removeEventListener("pointermove", move); window.removeEventListener("pointerup", up); };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };

  return (
    <div ref={ref} onPointerDown={(e) => drag(e, "move")}
      className="absolute border-2 border-violet-400/90 cursor-move pointer-events-auto"
      style={{ left: `${(x - w / 2) * 100}%`, top: `${(y - hFrac / 2) * 100}%`,
        width: `${w * 100}%`, height: `${hFrac * 100}%`, boxShadow: "0 0 0 1px rgba(0,0,0,0.5)" }}>
      <div onPointerDown={(e) => drag(e, "resize")}
        className="absolute -right-1.5 -bottom-1.5 w-3 h-3 bg-violet-400 rounded-sm cursor-nwse-resize"
        style={{ boxShadow: "0 0 0 1px rgba(0,0,0,0.5)" }} />
    </div>
  );
}
